import { render, staticRenderFns } from "./Institution.vue?vue&type=template&id=429923a8&scoped=true"
import script from "./Institution.vue?vue&type=script&lang=js"
export * from "./Institution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429923a8",
  null
  
)

export default component.exports